//user constants
export const GET_USERS = "GET_USERS";
export const SET_USERS = "SET_USERS";
export const DELETE_USERS = "DELETE_USERS";
export const EDIT_USERS = "EDIT_USERS";

//restaurant constants
export const GET_RESTAURANT = "GET_RESTAURANT";
export const SET_RESTAURANT = "SET_RESTAURANT";
export const SET_ID = "SET_ID";
export const SET_RESTAURANT_ID = "SET_RESTAURANT_ID"
export const BASIC_INFO = "BASIC_INFO";
export const EDIT_BASIC_INFO = "EDIT_BASIC_INFO";
export const EDIT_PAPERS = "EDIT_PAPERS";
export const EDIT_MEALS = "EDIT_MEALS";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_MEALS = "SET_MEALS";
export const SET_PLANS = "SET_PLANS";
export const SET_BANK_INFO = "SET_BANK_INFO";
export const SET_PROFIT_MARGINS = "SET_PROFIT_MARGINS"

//orders
export const GET_ORDERS = "GET_ORDERS";
export const SET_ORDERS = "SET_ORDERS";
export const SET_TOTAL_ORDERS = "SET_TOTAL_ORDERS";
export const SET_TOTAL_PENDING_ORDERS = "SET_TOTAL_PENDING_ORDERS";
export const SET_TOTAL_ACCEPTED_ORDERS = "SET_TOTAL_ACCEPTED_ORDERS";
export const SET_TOTAL_IN_PROGRESS_ORDERS = "SET_TOTAL_IN_PROGRESS_ORDERS";
export const SET_TOTAL_COMPLETED_ORDERS = "SET_TOTAL_COMPLETED_ORDERS";
export const SET_TOTAL_REJECTED_ORDERS = "SET_TOTAL_REJECTED_ORDERS";


//requests
export const GET_REQUESTS = "GET_REQUESTS";

//plans
export const GET_PLANS = "GET_PLANS";
export const EDIT_PLANS = "EDIT_PLANS";
export const GET_CHARGES = "GET_CHARGES";

export const orderReceived = "Dear Customer, Feasti received your order! Currently processing it and will notify you upon acceptance by our kitchen partner. Thanks for choosing Feasti!"
export const chefNewOrder = "New order from Feasti received. Respond within 45 mins to accept or reject."
export const acceptedMessage = "Great news! Your order has been approved by our kitchen partner."
export const rejectedMessage = "Unfortunately, our kitchen partner couldn't accept your order. Explore other options or contact us with any questions. Thank you!"
export const deliveryMessage = "Exciting news! Your order is on its way and will be delivered today."
export const deliverSuccessMessage = "Your delicious meal has been successfully delivered. We hope you enjoy every bite!"